import InvoicablesApi from './InvoicablesApi';
import InvoicesApi from './InvoicesApi';
import * as types from './InvoiceActionTypes';
import IFileUploads from './IFileUploads';

function getInvoicablesFilterSuccess(invoicablesFilter: any) {
    return {
        type: types.GET_INVOICABLES_FILTER_SUCCESS,
        result: invoicablesFilter
    };
}

export function getInvoicablesFilter() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        InvoicablesApi.getInvoicablesFilter().then((result: any) => {
            dispatch(getInvoicablesFilterSuccess(result));
        });
}

function getInvoicablesSuccess(invoicables: any) {
    return { type: types.GET_INVOICABLES_SUCCESS, result: invoicables };
}

export function getInvoicables(
    regionId: number,
    brokerChainId: number,
    country: number,
    legalEntityId: number,
    site: number,
    invoiceInterval: number
) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        InvoicablesApi.getInvoicables(
            regionId,
            brokerChainId,
            country,
            legalEntityId,
            site,
            invoiceInterval
        ).then((result: any) => {
            dispatch(getInvoicablesSuccess(result));
        });
}

function getNewInvoiceSuccess(newInvoice: any) {
    return { type: types.GET_NEW_INVOICE_SUCCESS, result: newInvoice };
}

export function getNewInvoice(
    invoiceDate: any,
    message: string,
    otherFirmName: string,
    otherInvoiceAddress: string,
    brokerFirmId: number,
    invoiceChecksum: number
) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        InvoicablesApi.newInvoice(
            invoiceDate,
            message,
            otherFirmName,
            otherInvoiceAddress,
            brokerFirmId,
            invoiceChecksum
        ).then((result: any) => {
            dispatch(getNewInvoiceSuccess(result));
        });
}

function createInvoiceSuccess(invoice: string) {
    return { type: types.CREATE_INVOICE_SUCCESS, result: invoice };
}

export function createInvoice(
    invoiceDate: any,
    language: string,
    message: string,
    otherFirmName: string,
    otherInvoiceAddress: string,
    brokerFirmId: number,
    invoiceChecksum: number,
    exchangeRate: number
) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        InvoicablesApi.createInvoice(
            invoiceDate,
            language,
            message,
            otherFirmName,
            otherInvoiceAddress,
            brokerFirmId,
            invoiceChecksum,
            exchangeRate
        ).then((invoice: string) => {
            dispatch(createInvoiceSuccess(invoice));
        });
}

function getNewCreditInvoiceSuccess(newCreditInvoice: any) {
    return {
        type: types.GET_NEW_CREDIT_INVOICE_SUCCESS,
        result: newCreditInvoice
    };
}

export function getNewCreditInvoice(
    invoiceId: number,
    invoiceDate: any,
    message: string,
    rows: any[]
) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        InvoicesApi.newCreditInvoice(invoiceId, invoiceDate, message, rows).then((result: any) => {
            dispatch(getNewCreditInvoiceSuccess(result));
        });
}

function createCreditInvoiceSuccess(result: any) {
    return { type: types.CREATE_CREDIT_INVOICE_SUCCESS, result: result };
}

export function createCreditInvoice(
    invoiceId: number,
    invoiceDate: any,
    message: string,
    rows: any[]
) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        InvoicesApi.createCreditInvoice(invoiceId, invoiceDate, message, rows).then(
            (result: any) => {
                dispatch(createCreditInvoiceSuccess(result));
            }
        );
}

function getInvoicesSuccess(invoices: any) {
    return { type: types.GET_INVOICES_SUCCESS, result: invoices };
}

export function getInvoices(filter: any) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        InvoicesApi.getInvoices(filter).then((result: any) => {
            dispatch(getInvoicesSuccess(result));
        });
}

function getInvoicesFilterSuccess(invoicesFilter: any) {
    return { type: types.GET_INVOICES_FILTER_SUCCESS, result: invoicesFilter };
}

export function getInvoicesFilter() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        InvoicesApi.getInvoicesFilter().then((result: any) => {
            dispatch(getInvoicesFilterSuccess(result));
        });
}

export function downloadInvoice(id: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        InvoicesApi.downloadInvoice(id);
}

function getNewPaymentSuccess(newPayment: any) {
    return { type: types.GET_NEW_PAYMENT_SUCCESS, result: newPayment };
}

export function getNewPayment(invoiceId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        InvoicesApi.newPayment(invoiceId).then((result: any) => {
            dispatch(getNewPaymentSuccess(result));
        });
}

function getPaymentsSuccess(payments: any) {
    return { type: types.GET_PAYMENTS_SUCCESS, result: payments };
}

export function getPayments(invoiceId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        InvoicesApi.getPayments(invoiceId).then((result: any) => {
            dispatch(getPaymentsSuccess(result));
        });
}

function createPaymentSuccess() {
    return { type: types.CREATE_PAYMENT_SUCCESS };
}

export function createPayment(
    invoiceId: number,
    date: Date,
    comment: string,
    amountInclVAT: number,
    amountIncludingVATInInvoiceCurrency: number,
    paymentType: number
) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        InvoicesApi.createPayment(
            invoiceId,
            date,
            comment,
            amountInclVAT,
            amountIncludingVATInInvoiceCurrency,
            paymentType
        ).then((result: any) => {
            dispatch(createPaymentSuccess());
        });
}

function importPaymentsSucceeded(result: any): any {
    return { type: types.IMPORT_PAYMENTS_SUCCESS, result: result };
}

export function importPayments(
    legalEntityId: number,
    fileuploads: IFileUploads
): (dispatch: (result: any) => void, getState: any) => any {
    return (dispatch: (result: any) => void, getState: any) =>
        InvoicesApi.importPayments(legalEntityId, fileuploads).then((result: any) => {
            dispatch(importPaymentsSucceeded(result));
        });
}

function newImportPaymentsSucceeded(result: any): any {
    return { type: types.NEW_IMPORT_PAYMENTS_SUCCESS, result: result };
}

export function newImportPayments(): (dispatch: (result: any) => void, getState: any) => any {
    return (dispatch: (result: any) => void, getState: any) =>
        InvoicesApi.newImportPayments().then((result: any) => {
            dispatch(newImportPaymentsSucceeded(result));
        });
}

function getInvoiceSuccess(invoice: any) {
    return { type: types.GET_INVOICE_SUCCESS, result: invoice };
}

export function getInvoice(invoiceId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        InvoicesApi.getInvoice(invoiceId).then((result: any) => {
            dispatch(getInvoiceSuccess(result));
        });
}

function tryInvoiceAgainSuccess(invoiceId: number) {
    return { type: types.TRY_INVOICE_AGAIN_SUCCESS, result: invoiceId };
}

export function tryInvoiceAgain(invoiceId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) => {
        InvoicesApi.tryInvoiceAgain(invoiceId).then((result: any) => {});

        return dispatch(tryInvoiceAgainSuccess(invoiceId));
    };
}

function createInvoicesSuccess(invoices: string[]) {
    return { type: types.CREATE_INVOICES_SUCCESS, result: invoices };
}

export const createInvoices = (selectedItems: any[], invoiceDate: any, languageKey: string) => {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        InvoicablesApi.createInvoices(
            selectedItems, invoiceDate, languageKey
        ).then((invoices: string[]) => {
            dispatch(createInvoicesSuccess(invoices));
        });    
};

function markAsVoidSuccess(markAsVoid: boolean) {
    return { type: types.MARK_AS_VOID_SUCCESS, result: markAsVoid };
}

export function markAsVoid(
    invoiceDate: any,
    language: string,
    message: string,
    otherFirmName: string,
    otherInvoiceAddress: string,
    brokerFirmId: number,
    invoiceChecksum: number
) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        InvoicablesApi.markAsVoid(
            invoiceDate,
            language,
            message,
            otherFirmName,
            otherInvoiceAddress,
            brokerFirmId,
            invoiceChecksum
        ).then((markedAsInvoiced: boolean) => {
            dispatch(markAsVoidSuccess(markedAsInvoiced));
        });
}
